import React, { useContext, useEffect, useState } from 'react';
import { WizardContext } from 'context/Context';
import { useNavigate } from 'react-router-dom';
import { Form, Row, Button } from 'react-bootstrap';
import Wrapper from './components/Wrapper';
import { getTimeWindow } from './components/Confirmed';
import { ConfigContext } from 'context/Context';
import { beforeToday } from 'si/helpers/beforeToday';

function ConfirmTile() {
  const { fabricator } = useContext(ConfigContext);
  const { job, handleAppointmentConfirmation } = useContext(WizardContext);
  const navigate = useNavigate();
  const [decision, setDecision] = useState('');
  const [rescheduleConfirm, setRescheduleConfirm] = useState(false);
  const [reason, setReason] = useState('');
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    // console.log('tile status', job?.tile?.status);
    console.log('job', job);
    if (
      job.id &&
      (!job.tileInstallDetails ||
        job?.tileInstallDetails?.reschedule ||
        beforeToday(job?.tileInstallDetails?.date) ||
        job?.install?.status === 'Installed' ||
        job?.install?.status === 'In Progress')
    ) {
      navigate('../');
    }
  }, [job.id, job?.tileInstallDetails]);

  useEffect(() => {
    if (job?.tileInstallDetails?.windowAnswered) {
      setDecided(true);
      if (job.tileInstallDetails.windowConfirmed) {
        setDecision('confirm');
      } else if (job.tileInstallDetails.reschedule) {
        setDecision('reschedule');
        navigate('../');
      } else {
        navigate('../');
      }
    }
  }, [job?.tileInstallDetails]);

  return decided ? (
    <Wrapper>
      <div className="container">
        <h5>Tile Arrival Window Confirmed</h5>
        <p>Fantastic we look forward to seeing you!</p>
        <p>Quick Checklist to be ready:</p>
        <ul>
          <li>
            Prepare the area - Items like shelves, microwaves, and lights if
            applicable
          </li>
          <li>
            Provide a Workspace - Ensure space for tools, easy access to power
            and water, and clear walkways
          </li>
          <li>
            Decision maker over 18 on site for the duration of the appointment
            to review details if necessary
          </li>
        </ul>
        <p>
          See you soon! If you have questions, please reach out to your project
          coordinator, {job?.PC.firstName} at{' '}
          <a href={`tel:1-${job?.PC?.phone || '800-548-4445'}`}>
            {job?.PC?.phone || '800.548.4445'}
          </a>
          .
        </p>
        <p style={{ fontStyle: 'italic' }}>
          If you have an emergency that requires you to reschedule, please call{' '}
          <a href={fabricator.phonelink}>{fabricator.phone}</a>
        </p>
      </div>
    </Wrapper>
  ) : (
    <Wrapper>
      <div className="container">
        <h5>Confirm Tile Arrival Window</h5>

        <Row>
          <p>
            Let’s make your kitchen shine! Your Tile Backsplash Installation is
            scheduled for {job?.tileInstallDetails?.dateFormatted}, and our team
            will arrive between{' '}
            <strong>
              {job?.tileInstallDetails?.time &&
                getTimeWindow(job?.tileInstallDetails?.time)}
            </strong>{' '}
            to bring your space to life!
          </p>
          <p className="fs--1">
            Click your choice below to move forward with your project:
          </p>
        </Row>

        <Form className="outdoor-field">
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="decision"
              id="confirm"
              label={`All set - see you then!`}
              checked={decision === 'confirm'}
              onChange={() => {
                setDecision('confirm');
              }}
            />
          </Row>
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="reschedule"
              id="yes"
              label={<>I need to reschedule</>}
              checked={decision === 'reschedule'}
              onChange={() => {
                setDecision('reschedule');
              }}
            />
          </Row>
        </Form>
        {decision === 'reschedule' && (
          <>
            <p>Are you sure you need to reschedule?</p>
            <p>
              Just a heads up - if we reschedule, we'll have to find the next
              available date.
            </p>
            <Form>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="textOK"
                  label="Yes, please contact me to reschedule"
                  checked={rescheduleConfirm}
                  onChange={({ target }) =>
                    setRescheduleConfirm(target.checked)
                  }
                  inline
                />
              </Form.Group>
              {rescheduleConfirm && (
                <>
                  <p className="fs--1" style={{ fontStyle: 'italic' }}>
                    Are there any scheduling concerns we should be aware of
                    while we look for a new date for you?{' '}
                  </p>
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      bssize="sm"
                      id="experienceDescription"
                      value={reason}
                      onChange={({ target }) => setReason(target.value)}
                      rows={5}
                      className="mb-3"
                    />
                  </Form.Group>
                </>
              )}
            </Form>
          </>
        )}
        <Button
          color="primary"
          className="mx-2 my-1 save-comment-btn"
          disabled={
            !decision || (decision === 'reschedule' && !rescheduleConfirm)
          }
          onClick={() => {
            handleAppointmentConfirmation({
              type: 'tile',
              decision,
              reason
            });
            if (decision === 'confirm') {
              setDecided(true);
            } else {
              navigate('../');
            }
          }}
        >
          Submit My Selection
        </Button>
      </div>
    </Wrapper>
  );
}

export default ConfirmTile;
